export class UrpProjektRequestDto {
  prId: number;
  basId: number;
  addKbs: boolean;
}
